import Slider from 'react-slick';
import React, { useCallback, useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getTestimonial } from '../tools/fetcher';

export default function TestimonialSlider() {
    const [testimonials, setTestimonials] = useState([]);

    const Slide = useCallback(
        ({ testy }) =>
            testy ? (
                <div className={'bg-white rounded-[20px] p-8 mr-4 sm:mr-10'}>
                    <div className={'flex items-center gap-6'}>
                        {testy?.imageSrc && (
                            <img
                                src={testy.imageSrc}
                                alt={testy?.imageAlt || testy?.name}
                                className={
                                    'h-[60px] w-[60px] object-contain rounded-full'
                                }
                            />
                        )}
                        <div>
                            <h1
                                className={
                                    'leading-[32px] font-bold text-[20px]'
                                }
                            >
                                {testy?.name}
                            </h1>
                            <p className={'leading-[28px] text-apart-black-50'}>
                                {testy?.position}
                            </p>
                        </div>
                    </div>
                    <p className={'text-apart-black-50 leading-[28px] mt-4'}>
                        {testy?.description}
                    </p>
                </div>
            ) : (
                <div>NOT FOUND</div>
            ),
        [],
    );
    const settings = {
        autoplay: true,
        autoplaySpeed: 10000,
        infinite: true,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        accessibility: false,
        // adaptiveHeight: true,
        swipeToSlide: true,
        // prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        // nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    dots: true,
                    dotsClass:
                        'mx-auto apart-dots w-[calc(50%-16px)] sm:w-[calc(50%-40px)] text-center !flex items-center justify-center mt-4 h-2 gap-2',
                    centerMode: true,
                    centerPadding: '24px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        getTestimonial().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    name: d?.title?.rendered,
                    position: d?.testimonial_details?.job_position,
                    imageSrc: d?.testimonial_details?.image_src,
                    imageAlt: d?.testimonial_details?.image_alt,
                    description: d?.testimonial_details?.description,
                }));
                setTestimonials(dt);
            }
        });
    }, []);

    return (
        <div className={'sm:col-span-2 overflow-hidden relative'}>
            <div className="w-[calc(100%+16px)] sm:w-[calc(100%+40px)] -ml-2 sm:ml-0">
                {testimonials.length > 0 && (
                    <Slider {...settings}>
                        {testimonials.map((testy, index) => (
                            <Slide key={index} testy={testy} />
                        ))}
                    </Slider>
                )}
            </div>
        </div>
    );
}
